module.exports = __webpack_public_path__ + "assets/vue.4903e576.svg";